import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  card: {
    backgroundColor: "x80m72e",
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    marginBottom: "xyi6m4r",
    $$css: true
  },
  header: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    marginBottom: "x1gr9t9r",
    $$css: true
  },
  icon: {
    color: "x1n9cmz0",
    flexShrink: "x2lah0s",
    $$css: true
  },
  title: {
    fontSize: "x1603h9y",
    fontWeight: "x1sl8krj",
    color: "xtt1gjl",
    $$css: true
  },
  rows: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  row: {
    display: "x78zum5",
    justifyContent: "x1qughib",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    fontSize: "x6u19be",
    $$css: true
  },
  day: {
    color: "xarw3lm",
    $$css: true
  },
  time: {
    color: "xarw3lm",
    $$css: true
  },
  strong: {
    color: "xtt1gjl",
    fontWeight: "x1sl8krj",
    $$css: true
  }
};